// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"263be899","931":"a5397a62"}[chunkId] + ".chunk.js";
};